import { z } from "zod";
import { clickedEmailFromSameCampaignConversionGetSchema } from "./clickedEmailFromSameCampaignConversionGetSchema";
import { madeAnyPurchaseConversionGetSchema } from "./madeAnyPurchaseConversionGetSchema";
import { openedEmailFromSameCampaignConversionGetSchema } from "./openedEmailFromSameCampaignConversionGetSchema";
import { performedCustomEventConversionGetSchema } from "./performedCustomEventConversionGetSchema";
import { purchasedProductConversionGetSchema } from "./purchasedProductConversionGetSchema";
import { upgradedAppVersionConversionGetSchema } from "./upgradedAppVersionConversionGetSchema";
import { usedAppConversionGetSchema } from "./usedAppConversionGetSchema";
import { placedOrderConversionGetSchema } from "./placedOrderConversionGetSchema";

export const conversionGetSchema = z.discriminatedUnion("event_type", [
  clickedEmailFromSameCampaignConversionGetSchema,
  madeAnyPurchaseConversionGetSchema,
  openedEmailFromSameCampaignConversionGetSchema,
  performedCustomEventConversionGetSchema,
  purchasedProductConversionGetSchema,
  upgradedAppVersionConversionGetSchema,
  usedAppConversionGetSchema,
  placedOrderConversionGetSchema,
]);
